import { render, staticRenderFns } from "./LinkTermsAndConditions.vue?vue&type=template&id=0c618618&scoped=true"
import script from "./LinkTermsAndConditions.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkTermsAndConditions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c618618",
  null
  
)

export default component.exports